import React from "react";

function SmartPlatform({ platform }) {
  return (
    <div className="lg:px-[5.69rem] px-3 flex lg:flex-row flex-col lg:gap-[4rem]">
      <div className="flex flex-col lg:flex-row justify-center gap-y-[2rem] items-center h-full w-full mt-[3rem] lg:mt-[-6rem]">
        <div className="flex flex-row lg:items-end items-center lg:max-w-[50%] w-full gap-[1rem] lg:gap-[1.5rem]">
          {platform?.images?.map((img, i) => (
            <img key={i} src={img} alt={`platform-${i + 1}`} loading="lazy" className="flex-1 lg:flex-none object-cover h-[12rem] lg:h-auto lg:w-[9rem]" style={{ borderRadius: "6.25rem" }} />
          ))}
        </div>
      </div>

      <div className="flex flex-col justify-center lg:max-w-[50%] w-full mt-[1rem]">
        <div>
          <div className="w-[3.25rem] h-[0.375rem] rounded-[1.25rem] bg-impalaRed" />
          <div className="mt-[1rem] text-ink font-lexend text-[1.25rem] font-[500] leading-[1.75rem] tracking-[-0.0175rem]">
            {platform?.title}
          </div>
          <div className="mt-[.5rem] text-body font-lexend text-[1.125rem] font-[400] leading-[1.625rem] tracking-[-0.0135rem] max-w-[30.1875rem]">
            {platform?.desc}
          </div>
        </div>

        <div className="flex flex-row flex-wrap gap-[1rem] items-center">
          {platform?.icons?.map((p, i) => (
            <img key={i} src={p} alt={`platform-icon-${i + 1}`} loading="lazy" className="h-[7rem] object-contain" />
          ))}
        </div>
      </div>
    </div>
  );
}

export default SmartPlatform;
